module.exports = __webpack_public_path__ + "static/media/ic-check-audit.4d172377.svg";